import React from 'react'
import { CBadge, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import AgencyDetailPanel from './AgencyDetailPanel'
import Meta from '../../shared/Meta'
import { icon } from '../../shared/icons'

function AgencyInformationPage({ agency, onBack }) {
  const active = String(agency.status) === '1'
  const plan = agency.payment_plan || {}

  return (
    <div className="agency-information-page">
      <div className="page-head agency-information-head">
        <div>
          <CButton color="link" className="agency-back-button" onClick={onBack}>
            <CIcon icon={icon('cilArrowLeft')} /> Volver a agencias
          </CButton>
          <h1>Información de la agencia</h1>
          <p>Administra sus PCCs dependientes, usuarios y permisos de dashboard.</p>
        </div>
      </div>

      <section className="agency-summary-card">
        <div className="row-top">
          <div>
            <span className="agency-summary-eyebrow">Agencia</span>
            <h2>{agency.name || 'Sin nombre'}</h2>
            <p>{agency.description || 'Sin descripción'}</p>
          </div>
          <CBadge color={active ? 'success' : 'danger'}>{active ? 'Activa' : 'Inactiva'}</CBadge>
        </div>
        <div className="meta-grid">
          <Meta label="Parent PCC" value={agency.parent_pcc || '-'} />
          <Meta label="Usuarios" value={plan.users ?? '-'} />
          <Meta label="Custom scripts" value={plan.custom_scripts ?? '-'} />
        </div>
      </section>

      <AgencyDetailPanel agency={agency} open />
    </div>
  )
}

export default AgencyInformationPage
